import { AnyAlbumEntityVersion, AnyTeamGroupEntityVersion, Collections } from '@uploadcam/common';
import {
  CollectionReference,
  doc,
  Firestore,
  getDocs,
  query,
  runTransaction,
  where,
} from 'firebase/firestore';
import { getCollectionRef } from '../../../../@harmony/angular';

export class DeleteTeamGroupInteractor {
  private readonly albumsCollection: CollectionReference<AnyAlbumEntityVersion>;
  private readonly teamGroupsCollection: CollectionReference<AnyTeamGroupEntityVersion>;

  constructor(private readonly db: Firestore) {
    this.albumsCollection = getCollectionRef(this.db, Collections.TeamAlbums);
    this.teamGroupsCollection = getCollectionRef(this.db, Collections.TeamGroups);
  }

  public async execute(groupId: string): Promise<void> {
    const albumsQuery = query(this.albumsCollection, where('groups', 'array-contains', groupId));
    const albumsDocs = await getDocs(albumsQuery);

    await runTransaction(this.db, async (transaction) => {
      const docRef = doc(this.teamGroupsCollection, groupId);
      transaction.delete(docRef);

      albumsDocs.docs.forEach((albumDoc) => {
        const albumGroups = albumDoc.data().groups ?? [];

        transaction.update(albumDoc.ref, {
          groups: albumGroups.filter((id) => id !== groupId),
        });
      });
    });
  }
}
